<template>
  <div class="w-auto btn second-btn-wrapper f16-l21 df16-l20 position-relative"  style="padding-top: 2px;" >
    <div v-if="field.options" class="align-items-center asmessage  d-flex flex-row position-relative">
      <div class="accordion-header pointer text-center d-flex flex-column f16-l21" @click="showOptions">{{field.label || "missing label"}}</div>
      <CaretComponent :open="optionsVisible" @click="showOptions" />
      <div v-show="optionsVisible">
        <div class="d-flex flex-column innerpopup" :ref="(el) => {this.innerPopupRef=el;}" > <!--:ref="group_id">-->
          <div v-for="(option,idx) in field.options" :key="`option--${idx}`" class="d-flex flex-row align-items-center">
            <input type="checkbox" class="red-checkbox" :id="option.tag_text + `_${idx}`" autocomplete="off" :value="option.val"  :checked="option.selected"/> 
            <label class="btn btn1 text-right d-flex flex-column f14-l18 nowrap" :for="option.tag_text + `_${idx}`">
              {{ option.text }}
            </label>
          </div>
          <ButtonComponent :caption="this.button.label" class="margin-top-15" variant="red_dropdown" @click="submitOptions()" @keyup.enter="submitOptions()"/>
        </div>
      </div>
    </div>
    <div v-else>
      <div :class="'align-items-center asmessage d-flex flex-row position-relative pointer f16-l21' + (field.selected ? ' yellow-message' : '')" @click="submitSingleButton( field )" :ref="(el) => {this.innerPopupRef=el;}">{{field.label || "missing label"}}</div>
      <FormHiddenFieldComponent type="hidden" :name="field.data_name" :value="field.val" />
    </div>
      <BGClickCatcherComponent v-show="optionsVisible" @click="showOptions" />
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
import FormHiddenFieldComponent from "@/components/form/FormHiddenFieldComponent";
import ButtonComponent from "@/components/form/ButtonComponent.vue";
export default {
  emits: ['selectorChanged', 'expandContainer'],
  components: {
    CaretComponent,
    BGClickCatcherComponent,
    FormHiddenFieldComponent,
    ButtonComponent
  },
  data() {
    return {
      optionsVisible: false,
      innerPopupRef: null,
    }
  },
  props: {
    field: Object,
    button: Object,
    group_index: Number
  },
  methods: {
    async showOptions() {
      this.optionsVisible = !this.optionsVisible;
      if (!this.$isDesktop() ) {
        this.emitter.emit('expandContainer', this.optionsVisible);
      }
      await this.$nextTick();
      if (!this.$isDesktop() && this.optionsVisible) {
        // Guard clause to check if this.innerPopupRef is null

        if (!this.innerPopupRef) return;
       
        if (this.innerPopupRef.getBoundingClientRect().x<0) {
          this.innerPopupRef.classList.add("innerpopup-left");
          this.innerPopupRef.classList.remove("innerpopup-right");
          this.innerPopupRef.classList.remove("innerpopup");
        }
        else if (this.innerPopupRef.getBoundingClientRect().right > window.innerWidth) {
          this.innerPopupRef.classList.add("innerpopup-right");
          this.innerPopupRef.classList.remove("innerpopup-left");
          this.innerPopupRef.classList.remove("innerpopup");
        }
        else {
          this.innerPopupRef.classList.remove("innerpopup-right");
          this.innerPopupRef.classList.remove("innerpopup-left");
          this.innerPopupRef.classList.add("innerpopup");
        }
      }
    },
    openSelectCity() {
      if ("select_city_popup" == this.availability?.on_click) {
        this.$store.dispatch('showSelectCity');
      }
    },
    submitSingleButton(field) {
      // console.log("submitSingleButton");
      if (field.new_tab && field.href.length > 0) {
        window.open(field.href);
      } else {
        let selected_value = (field.selected ? '' : field.val);
        let index = this.group_index;
        // console.log("submitSingleButton value: " + value.toString() + " group_index = " + index );
        this.$emit("selectorChanged", index, selected_value.toString());
      }
    },
    submitOptions() {
      const filterElm = this.innerPopupRef;
      const checkedCheckboxes = filterElm.querySelectorAll("input[type=checkbox]:checked");
      let selectedfilterIds = [];
      for (let i = 0; i < checkedCheckboxes.length; i++) {
        selectedfilterIds.push(checkedCheckboxes[i].getAttribute("value"));
      }
      let selectionStr = selectedfilterIds.join(',');
      let index = this.group_index;
      // this.optionsVisible = false
      this.showOptions();
      this.$emit("selectorChanged", index, selectionStr);
    }
  },
  computed: {
    alignment() {
      if (this.$isDesktop()) {
        return "justify-content-center align-items-center";
      }
      return "align-items-right";
    },
  },
}
</script>
<style scoped>
.asmessage {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin-left: 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding: 6px 20px 6px 20px;
}

.yellow-message {
  background: yellow;
}

.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}
.innerpopup-left {
  z-index: 4000;
  background: white;
  position: absolute;
  left: 50%;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}

.innerpopup-right{
  z-index: 4000;
  background: white;
  position: absolute;
  right: 50%;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;

}
</style>